import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes } from 'react-router';
import { routeElement } from './RouteComponent';
import { Container } from 'reactstrap';
import { toast, ToastContainer, Slide } from 'react-toastify';


import NavigationBar from '../containers/NavigationBar';
import VacanciesPage from '../containers/VacanciesPage';
import ArchivePage from '../containers/ArchivePage';
import CreateVacancy from '../containers/CreateVacancy';
import EditVacancy from '../containers/EditVacancy';
import ResponsesPage from '../containers/ResponsesPage';
import ResponseReview from '../containers/ResponseReview';
import CreateResponse from '../containers/CreateResponse';
import ProfilePage from '../containers/ProfilePage';
import TeamsPage from '../containers/TeamsPage';
import EditHiringTemplate from '../containers/EditHiringTemplate';
import HiringTemplatesPage from '../containers/HiringTemplatesPage';
import TariffsPage from '../components/TariffsPage';
import PaymentPage from '../components/PaymentPage';
import Footer from '../components/Footer';
import LicenseAgreement from '../components/LicenseAgreement';
import PaymentSuccessPage from '../containers/PaymentSuccessPage';
import WidgetCustomizationPage from '../containers/WidgetCustomizationPage';
import NotFoundPage from '../components/NotFoundPage';
import FieldSetsPage from '../containers/FieldSetsPage';
import EditFieldSets from '../containers/EditFieldSets';
import QuestionsPage from '../containers/QuestionsPage';
import preloader from '../assets/img/preloader.gif';
import WebSocketInstance, { WSCommands } from '../utils/websocket';
import ReportPage from '../containers/ReportPage';
import ImportHhVacancies from '../components/ImportHhVacancies';
import SourcesPage from '../containers/SourcesPage';


export default class PrivateRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage.getItem('token') || null,
    };
  }

  componentDidMount() {
    const { token } = this.state;
    if (import.meta.env.PROD) {
      if (token) {
        this.webSocketConnect();
      }
    }
  }

  componentDidUpdate() {
    const { token } = this.state;
    const localStorageToken = localStorage.getItem('token');

    if (localStorageToken !== token) {
      this.onTokenUpdate(localStorageToken);
    }
  }

  componentWillUnmount() {
    if (import.meta.env.PROD) {
      WebSocketInstance.removeCallbacks([WSCommands.SHOW_MESSAGE]);
    }
  }

  onTokenUpdate = (token) => {
    this.setState({ token }, () => this.webSocketConnect());
  }

  onNewMessage = (data) => {
    const { message, status } = data;
    toast[status](message);
  };

  webSocketConnect = () => {
    WebSocketInstance.connect();
    WebSocketInstance.addCallbacks({ [WSCommands.SHOW_MESSAGE]: this.onNewMessage });
  }

  render() {
    const { dataLoaded, activeTeamShortId } = this.props;
    return (
      <>
        <ToastContainer
          transition={Slide}
          autoClose={15000}
          newestOnTop
          pauseOnFocusLoss
          hideProgressBar
        />
        <NavigationBar />
        <Container className="private-page-container">
          {dataLoaded
            ? (
              <Routes>
                <Route
                  path="/"
                  element={<Navigate to={`/teams/${activeTeamShortId}/vacancies`} replace />}
                />
                <Route
                  path="/teams/:shortId/vacancies"
                  element={routeElement(VacanciesPage)}
                />
                <Route
                  path="/teams/:shortId/vacancies/import"
                  element={routeElement(ImportHhVacancies)}
                />
                <Route
                  path="/teams/:shortId/archive"
                  element={routeElement(ArchivePage)}
                />
                <Route
                  path="/teams/:shortId/create-vacancy"
                  element={routeElement(CreateVacancy)}
                />
                <Route
                  path="/teams/:shortId/vacancies/responses"
                  element={routeElement(ResponsesPage)}
                />
                <Route
                  path="/teams/:shortId/vacancies/:id"
                  element={routeElement(EditVacancy)}
                />
                <Route
                  path="/teams/:shortId/archive/:id"
                  element={routeElement(EditVacancy, { mode: 'archive' })}
                />
                <Route
                  path="/teams/:shortId/vacancies/:vacancyId/responses"
                  element={routeElement(ResponsesPage)}
                />
                <Route
                  path="/teams/:shortId/vacancies/:vacancyId/responses/:responseId"
                  element={routeElement(ResponseReview)}
                />
                <Route
                  path="/teams/:shortId/vacancies/responses/create-response"
                  element={routeElement(CreateResponse)}
                />
                <Route
                  path="/teams/:shortId/widget-customization"
                  element={routeElement(WidgetCustomizationPage)}
                />
                <Route
                  path="/companies"
                  element={routeElement(TeamsPage)}
                />
                <Route
                  path="/teams/:shortId/templates/"
                  element={routeElement(HiringTemplatesPage)}
                />
                <Route
                  path="/teams/:shortId/templates/:templateId"
                  element={routeElement(EditHiringTemplate)}
                />
                <Route
                  path="/tariffs"
                  element={routeElement(TariffsPage)}
                />
                <Route
                  path="/tariffs/payment"
                  element={routeElement(PaymentPage)}
                />
                <Route
                  path="/payment/success"
                  element={routeElement(PaymentSuccessPage)}
                />
                <Route
                  path="/profile"
                  element={routeElement(ProfilePage)}
                />
                <Route
                  path="/teams/:shortId/field-sets"
                  element={routeElement(FieldSetsPage)}
                />
                <Route
                  path="/teams/:shortId/field-sets/:fieldSetId"
                  element={routeElement(EditFieldSets)}
                />
                <Route
                  path="/license-agreement"
                  element={routeElement(LicenseAgreement)}
                />
                <Route
                  path="/teams/:shortId/questions"
                  element={routeElement(QuestionsPage)}
                />
                <Route
                  path="/teams/:shortId/sources"
                  element={routeElement(SourcesPage)}
                />
                <Route
                  path="/login"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/signup"
                  element={<Navigate to="/" replace />}
                />
                <Route
                  path="/report"
                  element={routeElement(ReportPage)}
                />
                <Route
                  path="*"
                  element={routeElement(NotFoundPage)}
                />
              </Routes>
            )
            : (
              <div className="loader">
                <img className="loader__gif" src={preloader} alt="Загрузка..." />
              </div>
            )}
        </Container>
        <Footer />
      </>
    );
  }
}

PrivateRoutes.defaultProps = {
  activeTeamShortId: null,
};

PrivateRoutes.propTypes = {
  dataLoaded: PropTypes.bool.isRequired,
  activeTeamShortId: PropTypes.string,
};
